(function () {
  if (window.__suiLoaded) return;
  window.__suiLoaded = true;

  var saved = null;

  function rootOf(el) {
    return el.closest('[data-size-selector]');
  }
  function sectionOf(root) {
    return root.getAttribute('data-section');
  }
  function setPill(section, text) {
    document
      .querySelectorAll('[data-sui-overlay][data-section="' + section + '"] [data-sui-pill]')
      .forEach(function (p) {
        p.textContent = text || '';
        p.hidden = !text;
      });
  }
  function syncPill(root) {
    var s = root.querySelector('button.sui__opt.is-selected');
    if (s) setPill(sectionOf(root), s.getAttribute('data-pill') || '');
  }

  function restore() {
    if (!saved) return;
    var s = saved;
    saved = null;
    if (s.img) {
      if (s.srcset !== null) s.img.setAttribute('srcset', s.srcset);
      else s.img.removeAttribute('srcset');
      s.img.setAttribute('src', s.src);
    }
    syncPill(s.root);
  }

  function preview(opt) {
    if (opt.classList.contains('is-selected')) return;
    var root = rootOf(opt);
    if (!root) return;
    var section = sectionOf(root);
    restore();
    setPill(section, opt.getAttribute('data-pill') || '');
    var gallery = document.getElementById('MediaGallery-' + section);
    var img = gallery ? gallery.querySelector('.product__media-item.is-active img') : null;
    var url = opt.getAttribute('data-img');
    saved = { root: root, img: null };
    if (url && img) {
      saved.img = img;
      saved.src = img.getAttribute('src');
      saved.srcset = img.getAttribute('srcset');
      img.removeAttribute('srcset');
      img.setAttribute('src', url);
    }
  }

  function mark(opt) {
    var root = rootOf(opt);
    root.querySelectorAll('button.sui__opt').forEach(function (o) {
      var on = o === opt;
      o.classList.toggle('is-selected', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      var box = o.closest('.sui__box');
      if (box) box.classList.toggle('is-selected', on);
    });
    syncPill(root);
  }

  function choose(opt) {
    restore();
    if (opt.classList.contains('is-selected')) return;
    mark(opt);
    var section = sectionOf(rootOf(opt));
    var wrap = document.getElementById('variant-selects-' + section);
    if (!wrap) return;
    var value = opt.getAttribute('data-value');
    var inputs = wrap.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        if (!inputs[i].checked) {
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }
    var select = wrap.querySelector('select');
    if (select) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function feedback(btn, ok) {
    btn.classList.remove('is-busy');
    if (!ok) return;
    btn.classList.add('is-done');
    btn.textContent = '✓';
    setTimeout(function () {
      btn.classList.remove('is-done');
      btn.textContent = '+';
    }, 1500);
  }

  // Presses the real Add to cart button once the product form has switched to the wanted size.
  function addVariant(btn, section, variantId) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var tries = 0;
    (function wait() {
      var form = document.getElementById('product-form-' + section);
      var input = form ? form.querySelector('input[name="id"]') : null;
      var submit = document.getElementById('ProductSubmitButton-' + section);
      if (input && (!variantId || input.value === variantId) && submit) {
        if (submit.disabled) {
          feedback(btn, false);
          return;
        }
        submit.click();
        feedback(btn, true);
        return;
      }
      tries++;
      if (tries > 50) {
        feedback(btn, false);
        return;
      }
      setTimeout(wait, 100);
    })();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var imgadd = t.closest('.sui__imgadd');
    if (imgadd) {
      e.stopPropagation();
      var ov = imgadd.closest('[data-sui-overlay]');
      addVariant(imgadd, ov.getAttribute('data-section'), null);
      return;
    }

    var add = t.closest('.sui__add');
    if (add) {
      var root = rootOf(add);
      var box = add.closest('.sui__box');
      var opt = box ? box.querySelector('button.sui__opt') : null;
      if (opt) choose(opt);
      addVariant(add, sectionOf(root), add.getAttribute('data-variant-id'));
      return;
    }

    var o = t.closest('button.sui__opt');
    if (o) choose(o);
  });

  document.addEventListener('mouseover', function (e) {
    var o = e.target.closest ? e.target.closest('button.sui__opt') : null;
    if (o) preview(o);
  });
  document.addEventListener('mouseout', function (e) {
    var o = e.target.closest ? e.target.closest('button.sui__opt') : null;
    if (o && !o.contains(e.relatedTarget)) restore();
  });
  document.addEventListener('focusin', function (e) {
    var o = e.target.closest ? e.target.closest('button.sui__opt') : null;
    if (o) preview(o);
  });
  document.addEventListener('focusout', function (e) {
    var o = e.target.closest ? e.target.closest('button.sui__opt') : null;
    if (o) restore();
  });

  // Keep the boxes in sync when the size is changed with the original picker.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wrap = t.closest('[id^="variant-selects-"]');
    if (!wrap) return;
    var section = wrap.id.replace('variant-selects-', '');
    var root = document.getElementById('sui-' + section);
    if (!root) return;
    var opts = root.querySelectorAll('button.sui__opt');
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-value') === t.value) {
        restore();
        mark(opts[i]);
        return;
      }
    }
  });
})();
